import React from 'react';
import BaseIcon from './BaseIcon';

const pathData = [
  'M11.7411 1.54322L13.1438 0.140487C13.3318 -0.046829 13.6358 -0.046829 13.8238 0.140487L15.86 ',
  '2.17668C16.0467 2.36451 16.0467 2.66787 15.86 2.8557L14.4572 4.25843L11.7411 1.54322ZM2.92002 ',
  '13.1135L1.56553 11.7679L0.022534 15.7831C-0.0444753 15.9574 0.0430835 16.044 0.217308 ',
  '15.977L4.23787 14.434L2.92002 13.1135ZM12.5041 3.73219L11.0246 2.26066L2.25886 11.0264L4.97497 ',
  '13.7425L13.7416 4.97498L12.5041 3.73219Z',
].join('');

const SigningTextIcon = props => (
  <BaseIcon {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path d={pathData} />
    </g>
  </BaseIcon>
);


export default SigningTextIcon;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Icons/SigningTextIcon.jsx